/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfIEnumerableOfCommunicationDto,
  DataEnvelopeOfIEnumerableOfDepartmentDto,
  DataEnvelopeOfIEnumerableOfUserDto,
  DataEnvelopeOfSearchResultDto,
  ErrorEnvelope,
  SearchCommunicationsParams,
  SearchDepartmentsParams,
  SearchGlobalParams,
  SearchUsersParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * Busca global em comunicados, usuários, departamentos e respostas
 */
export const searchGlobal = (
  params: SearchGlobalParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfSearchResultDto>(
    { url: `/v1/search/global`, method: 'GET', params, signal },
    options,
  )
}

export const getSearchGlobalQueryKey = (params?: SearchGlobalParams) => {
  return [`/v1/search/global`, ...(params ? [params] : [])] as const
}

export const getSearchGlobalQueryOptions = <
  TData = Awaited<ReturnType<typeof searchGlobal>>,
  TError = ErrorEnvelope,
>(
  params: SearchGlobalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGlobal>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchGlobalQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchGlobal>>> = ({ signal }) =>
    searchGlobal(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchGlobal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof searchGlobal>>>
export type SearchGlobalQueryError = ErrorEnvelope

export function useSearchGlobal<
  TData = Awaited<ReturnType<typeof searchGlobal>>,
  TError = ErrorEnvelope,
>(
  params: SearchGlobalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGlobal>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGlobal>>,
          TError,
          Awaited<ReturnType<typeof searchGlobal>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchGlobal<
  TData = Awaited<ReturnType<typeof searchGlobal>>,
  TError = ErrorEnvelope,
>(
  params: SearchGlobalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGlobal>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchGlobal>>,
          TError,
          Awaited<ReturnType<typeof searchGlobal>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchGlobal<
  TData = Awaited<ReturnType<typeof searchGlobal>>,
  TError = ErrorEnvelope,
>(
  params: SearchGlobalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGlobal>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchGlobal<
  TData = Awaited<ReturnType<typeof searchGlobal>>,
  TError = ErrorEnvelope,
>(
  params: SearchGlobalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchGlobal>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchGlobalQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Busca em comunicados por termo
 */
export const searchCommunications = (
  params: SearchCommunicationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfCommunicationDto>(
    { url: `/v1/search/communications`, method: 'GET', params, signal },
    options,
  )
}

export const getSearchCommunicationsQueryKey = (params?: SearchCommunicationsParams) => {
  return [`/v1/search/communications`, ...(params ? [params] : [])] as const
}

export const getSearchCommunicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchCommunications>>,
  TError = ErrorEnvelope,
>(
  params: SearchCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchCommunicationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCommunications>>> = ({ signal }) =>
    searchCommunications(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchCommunications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchCommunicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchCommunications>>
>
export type SearchCommunicationsQueryError = ErrorEnvelope

export function useSearchCommunications<
  TData = Awaited<ReturnType<typeof searchCommunications>>,
  TError = ErrorEnvelope,
>(
  params: SearchCommunicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchCommunications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCommunications>>,
          TError,
          Awaited<ReturnType<typeof searchCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCommunications<
  TData = Awaited<ReturnType<typeof searchCommunications>>,
  TError = ErrorEnvelope,
>(
  params: SearchCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchCommunications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCommunications>>,
          TError,
          Awaited<ReturnType<typeof searchCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCommunications<
  TData = Awaited<ReturnType<typeof searchCommunications>>,
  TError = ErrorEnvelope,
>(
  params: SearchCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchCommunications<
  TData = Awaited<ReturnType<typeof searchCommunications>>,
  TError = ErrorEnvelope,
>(
  params: SearchCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchCommunicationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Busca em usuários por termo
 */
export const searchUsers = (
  params: SearchUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfUserDto>(
    { url: `/v1/search/users`, method: 'GET', params, signal },
    options,
  )
}

export const getSearchUsersQueryKey = (params?: SearchUsersParams) => {
  return [`/v1/search/users`, ...(params ? [params] : [])] as const
}

export const getSearchUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = ErrorEnvelope,
>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchUsersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) =>
    searchUsers(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersQueryError = ErrorEnvelope

export function useSearchUsers<
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = ErrorEnvelope,
>(
  params: SearchUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = ErrorEnvelope,
>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsers>>,
          TError,
          Awaited<ReturnType<typeof searchUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchUsers<
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = ErrorEnvelope,
>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchUsers<
  TData = Awaited<ReturnType<typeof searchUsers>>,
  TError = ErrorEnvelope,
>(
  params: SearchUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchUsersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Busca em departamentos por termo
 */
export const searchDepartments = (
  params: SearchDepartmentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfDepartmentDto>(
    { url: `/v1/search/departments`, method: 'GET', params, signal },
    options,
  )
}

export const getSearchDepartmentsQueryKey = (params?: SearchDepartmentsParams) => {
  return [`/v1/search/departments`, ...(params ? [params] : [])] as const
}

export const getSearchDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDepartments>>,
  TError = ErrorEnvelope,
>(
  params: SearchDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSearchDepartmentsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDepartments>>> = ({ signal }) =>
    searchDepartments(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDepartments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchDepartmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDepartments>>
>
export type SearchDepartmentsQueryError = ErrorEnvelope

export function useSearchDepartments<
  TData = Awaited<ReturnType<typeof searchDepartments>>,
  TError = ErrorEnvelope,
>(
  params: SearchDepartmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDepartments>>,
          TError,
          Awaited<ReturnType<typeof searchDepartments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDepartments<
  TData = Awaited<ReturnType<typeof searchDepartments>>,
  TError = ErrorEnvelope,
>(
  params: SearchDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDepartments>>,
          TError,
          Awaited<ReturnType<typeof searchDepartments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDepartments<
  TData = Awaited<ReturnType<typeof searchDepartments>>,
  TError = ErrorEnvelope,
>(
  params: SearchDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchDepartments<
  TData = Awaited<ReturnType<typeof searchDepartments>>,
  TError = ErrorEnvelope,
>(
  params: SearchDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchDepartmentsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
